import "./styles.css";

import { motion } from "framer-motion";
import { MenuToggle } from "./Hamburger";
import { Navigation } from "./Items";

const sidebar = {
  open: {
    clipPath: "circle(150vmax at 40px 40px)",
    transition: {
      duration: 0.65,
      ease: [0.16, 1, 0.3, 1],
    },
  },
  closed: {
    clipPath: "circle(20px at 40px 40px)",
    transition: {
      duration: 0.4,
      ease: [0.7, 0, 0.84, 0],
    },
  },
};

const SidebarNav = ({ isOpen, toggleOpen }: any) => {
  return (
    <motion.nav
      className="mobile-nav"
      initial={false}
      animate={isOpen ? "open" : "closed"}
      style={{
        zIndex: 1000,
      }}
    >
      {isOpen ? (
        <motion.div
          className="navbar"
          variants={sidebar}
          style={{
            zIndex: 3,
          }}
        />
      ) : (
        <motion.div
          variants={sidebar}
          style={{
            zIndex: 3,
          }}
        />
      )}
      <Navigation isOpen={isOpen} toggle={() => toggleOpen()} />
      <MenuToggle isOpen={isOpen} toggle={() => toggleOpen()} />
    </motion.nav>
  );
};

export default SidebarNav;
